<template>
    <div class="public_container personnel_add_wrap" v-loading="loading">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true" :isCustomReturnEvent="true" @returnEvent="handleClickReturnRouter">

            </ReturnNavBar>
        </div>
        <div class="mobile_container">
            <CustomFormMobile
                ref="personnel_custom_form"
                :field_list="formInfoList"
                :is_form_module="true"
                @submit-form="submitFormData"
                v-if="dataLoaded"
            />
        </div>
        <div class="add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">提交</van-button>
        </div>
    </div>
</template>

<script>
import {EventBus} from '@/utils/eventBus';
import {removeTag} from "@/utils";
import { getFormFields, addUser } from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import CustomFormMobile from "@/components/mComponents/CustomFormMobile";
export default {
    name: "MPersonnelAdd",
    components: { ReturnNavBar, CustomFormMobile },
    data() {
        return {
            loading: false,
            formInfoList: [],
            dataLoaded: false,
            btnDisabled: false,
        };
    },
    created() {
        this._getFromFields();
    },
    methods: {
        handleClickReturnRouter() {
            removeTag(this.$route)
            this.$router.go(-1);
        },
        //表单字段获取
        _getFromFields() {
            this.loading = true;
            getFormFields({
                field_form: "users",
            }).then((res) => {
                if (res.code === 200) {
                    this.formInfoList = res.data;
                    this.loading = false;
                    this.dataLoaded = true;
                }
            });
        },
        handleClickConfirm() {
            this.$refs.personnel_custom_form.handleClickPublish();
        },
        // 提交
        submitFormData(customForm) {
            if (customForm) {
                addUser(customForm).then((res) => {
                    if (res.code === 200) {
                        this.$toast({
                            message: "新增成功",
                            type: "success",
                            duration: 1000,
                            onClose: () => {
                                removeTag(this.$route);
                                EventBus.$emit('personnelAddUpdated');
                                this.$router.go(-1);
                            },
                        });
                    }
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.personnel_add_wrap {
    .mobile_container {
        padding: 10px 0;
    }
    .add_footer_wrap {
        padding: 5px 16px;
        background-color: #f7f8fa;

        .van-button {
            border-radius: 8px;
            height: 38px;
            background-color: rgba(41, 144, 240, 1);
            border-color: rgba(41, 144, 240, 1);
        }
    }
}
</style>
